import moment from "moment";
import React from "react";
import { Modal } from "react-bootstrap";
import Cropper from "react-cropper";
import { ClipLoader } from "react-spinners";
import { Apiurl } from "../../Pages/utils/page";
import { IoMdClose } from "react-icons/io";

const UploadandListingEditProductModal = ({
  editModal,
  handleCloseEditModal,
  editData,
  setEditData,
  editErrorMessage,
  setEditErrorMessage,
  currentDate,
  deliveryCharge,
  handleEditImageUpload,
  editImages,
  cropperRefs,
  selectedEditImageIndex,
  setSelectedEditImageIndex,
  setEditModal,
  loading,
  handleUpdateProduct,
  oldImages,
  setOldImages,
}) => {
  // const handleRadioChange = (index) => {
  //   const updatedImages = oldImages?.map((img, i) => ({
  //     ...img,
  //     default: i === index, // Set clicked image as Default, others to false
  //   }));
  //   setOldImages(updatedImages);
  // };
  const handleRadioChange = (id) => {
    // Update oldImages: set all `default` values to false, except the selected one
    const updatedImages = oldImages?.map((img, i) => ({
      ...img,
      Default: img.Id === id, // Set clicked old image as Default
    }));

    setOldImages(updatedImages); // Update state
    setSelectedEditImageIndex(null); // Reset editImages selection
  };
  const handleDelete = (id) => {
    const updatedImages = oldImages?.map((img) => ({
      ...img,
      Default: img.Id === id ? false : img.Default, // Reset Default only for the deleted image
      IsDelete: img.IsDelete || img.Id === id, // Preserve previous deletions and mark current one
    }));
  
    setOldImages(updatedImages); // Update state
  };

  const handleEditImageChange = (index) => {
    // When an editImage is selected, reset oldImages Defaults
    const updatedOldImages = oldImages?.map((img) => ({
      ...img,
      Default: false,
    }));

    setOldImages(updatedOldImages); // Reset oldImages
    setSelectedEditImageIndex(index); // Set selected edit image
  };

  return (
    <Modal
      show={editModal}
      onHide={handleCloseEditModal}
      backdrop="static"
      className="editproductModal"
    >
      <Modal.Header closeButton>
        <h4 className="modal-title common_heading">Confirm</h4>
      </Modal.Header>
      <Modal.Body className="popup_body_scroll">
        <div className="product-details">
          <form className="form">
            <div className="row">
              <div className="col-lg-6">
                <div className="form-group">
                  <label for="name" className="required-label">
                    Product Name
                    <span className="required">*</span>
                  </label>
                  <input
                    id="name"
                    className="form-control"
                    type="text"
                    placeholder="Name"
                    value={editData?.ProductName}
                    onChange={(e) => {
                      setEditData({
                        ...editData,
                        ProductName: e?.target?.value,
                      });
                      setEditErrorMessage({
                        ...editErrorMessage,
                        ProductName: "",
                      });
                    }}
                  />
                  {editErrorMessage?.ProductName ? (
                    <div className="validation-message">
                      {editErrorMessage?.ProductName}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label for="Brandname" className="required-label">
                    Brand Name
                    <span className="required">*</span>
                  </label>
                  <input
                    id="Brandname"
                    className="form-control"
                    type="text"
                    placeholder="Brand Name"
                    value={editData?.BrandName}
                    onChange={(e) => {
                      setEditData({
                        ...editData,
                        BrandName: e?.target?.value,
                      });
                      setEditErrorMessage({
                        ...editErrorMessage,
                        BrandName: "",
                      });
                    }}
                  />
                  {editErrorMessage?.BrandName ? (
                    <div className="validation-message">
                      {editErrorMessage?.BrandName}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label for="description" className="required-label">
                    Product Description
                    <span className="required">*</span>
                  </label>
                  <textarea
                    id="description"
                    rows="1"
                    className="form-control"
                    placeholder="Description"
                    value={editData?.ProductDescription}
                    onChange={(e) => {
                      setEditData({
                        ...editData,
                        ProductDescription: e?.target?.value,
                      });
                      setEditErrorMessage({
                        ...editErrorMessage,
                        ProductDescription: "",
                      });
                    }}
                  ></textarea>
                  {editErrorMessage?.ProductDescription ? (
                    <div className="validation-message">
                      {editErrorMessage?.ProductDescription}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label for="mrp" className="required-label">
                    MRP
                    <span className="required">*</span>
                  </label>
                  <input
                    id="mrp"
                    className="form-control"
                    type="text"
                    placeholder="MRP"
                    value={editData?.Mrp}
                    onChange={(e) => {
                      setEditData({ ...editData, Mrp: e?.target?.value });
                      setEditErrorMessage({
                        ...editErrorMessage,
                        Mrp: "",
                      });
                    }}
                  />
                  {editErrorMessage?.Mrp ? (
                    <div className="validation-message">
                      {editErrorMessage?.Mrp}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label for="quantity" className="required-label">
                    Quantity
                    <span className="required">*</span>
                  </label>
                  <input
                    id="quantity"
                    className="form-control"
                    type="number"
                    placeholder="Quantity"
                    value={editData?.Quantity}
                    onChange={(e) => {
                      setEditData({
                        ...editData,
                        Quantity: e?.target?.value,
                      });
                      setEditErrorMessage({
                        ...editErrorMessage,
                        Quantity: "",
                      });
                    }}
                  />
                  {editErrorMessage?.Quantity ? (
                    <div className="validation-message">
                      {editErrorMessage?.Quantity}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="required-label">
                    Product In Offer?
                    <span className="required">*</span>
                  </label>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <input
                      type="radio"
                      id="yes"
                      name="IsProductInOffer"
                      checked={editData?.IsProductInOffer == "bid"}
                      onChange={() => {
                        setEditData({ ...editData, IsProductInOffer: "bid" });
                        setEditErrorMessage({
                          ...editErrorMessage,
                          IsProductInOffer: "",
                        });
                      }}
                    />
                    <label for="yes">Is In Offer</label>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <input
                      type="radio"
                      id="no"
                      name="IsProductInOffer"
                      checked={editData?.IsProductInOffer == "buy"}
                      onChange={() => {
                        setEditData({ ...editData, IsProductInOffer: "buy" });
                        setEditErrorMessage({
                          ...editErrorMessage,
                          IsProductInOffer: "",
                        });
                      }}
                    />
                    <label for="no">Is In Buy</label>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <input
                      type="radio"
                      id="contact"
                      name="IsProductInOffer"
                      checked={editData?.IsProductInOffer == "contact"}
                      onChange={() => {
                        setEditData({
                          ...editData,
                          IsProductInOffer: "contact",
                        });
                        setEditErrorMessage({
                          ...editErrorMessage,
                          IsProductInOffer: "",
                        });
                      }}
                    />
                    <label for="contact">Is In Contact</label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                {editData?.IsProductInOffer == "bid" ? (
                  <>
                    <div className="form-group">
                      <label for="dealPrice">
                        Recommended Bid
                        <span className="required">*</span>
                      </label>
                      <input
                        id="dealPrice"
                        className="form-control"
                        type="text"
                        placeholder="Recommended Bid"
                        value={editData?.RecommendedBid}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            RecommendedBid: e?.target?.value,
                          })
                        }
                      />
                    </div>
                    {editErrorMessage?.RecommendedBid ? (
                      <div className="validation-message">
                        {editErrorMessage?.RecommendedBid}
                      </div>
                    ) : null}
                  </>
                ) : (
                  <>
                    <div className="form-group">
                      <label for="dealPrice">
                        Deal Price
                        <span className="required">*</span>
                      </label>
                      <input
                        id="dealPrice"
                        className="form-control"
                        type="text"
                        placeholder="Deal Price"
                        value={editData?.DealPrice}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            DealPrice: e?.target?.value,
                          })
                        }
                      />
                    </div>
                    {editErrorMessage?.DealPrice ? (
                      <div className="validation-message">
                        {editErrorMessage?.DealPrice}
                      </div>
                    ) : null}
                  </>
                )}
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label for="fromPublishDate" className="required-label">
                    From Publish Date
                    <span className="required">*</span>
                  </label>
                  <input
                    id="fromPublishDate"
                    type="date"
                    className="form-control"
                    placeholder="Publish Date"
                    min={currentDate}
                    value={
                      moment(editData.FromPublishDate).format("YYYY-MM-DD") ||
                      ""
                    }
                    onChange={(e) => {
                      setEditData({
                        ...editData,
                        FromPublishDate: moment(e?.target?.value).format(
                          "YYYY-MM-DDT00:00:00"
                        ),
                      });
                      setEditErrorMessage({
                        ...editErrorMessage,
                        FromPublishDate: "",
                      });
                    }}
                  />
                  {editErrorMessage?.FromPublishDate ? (
                    <div className="validation-message">
                      {editErrorMessage?.FromPublishDate}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label for="toPublishDate" className="required-label">
                    To Publish Date
                    <span className="required">*</span>
                  </label>
                  <input
                    id="toPublishDate"
                    type="date"
                    className="form-control"
                    placeholder="Publish Date"
                    min={moment(editData.FromPublishDate).format("YYYY-MM-DD")}
                    disabled={!editData?.FromPublishDate}
                    value={
                      moment(editData.ToPublishDate).format("YYYY-MM-DD") || ""
                    }
                    onChange={(e) => {
                      setEditData({
                        ...editData,
                        ToPublishDate: moment(e?.target?.value).format(
                          "YYYY-MM-DDT00:00:00"
                        ),
                      });
                      setEditErrorMessage({
                        ...editErrorMessage,
                        ToPublishDate: "",
                      });
                    }}
                  />
                  {editErrorMessage?.ToPublishDate ? (
                    <div className="validation-message">
                      {editErrorMessage?.ToPublishDate}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="required-label">
                    Delivery Charges
                    <span className="required">*</span>
                  </label>
                  <select
                    className="form-select"
                    onChange={(e) => {
                      const selectedValue = e?.target?.value;
                      const selectedItem = deliveryCharge?.find(
                        (item) => item?.Id === selectedValue
                      );
                      setEditData({
                        ...editData,
                        DeliveryCharges: selectedItem?.DeliveryCharge,
                      });
                    }}
                    value={editData?.DeliveryCharges || ""}
                  >
                    <option disabled>-- Select Delivery Charge--</option>
                    <option value="0">0</option>
                    {deliveryCharge?.map((item) => {
                      return (
                        <option value={item?.DeliveryCharges}>
                          {item?.DeliveryCharge}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label for="expiryTime" className="required-label">
                    Select Expiry Time of Item
                    <span className="required">*</span>
                  </label>
                  <input
                    id="expiryTime"
                    type="time"
                    className="form-control"
                    value={
                      editData.ProductExpiringTime
                        ? moment(
                            editData.ProductExpiringTime.split("T")[0] +
                              "T" +
                              editData.ProductExpiringTime.split("T")[1].slice(
                                0,
                                5
                              )
                          ).format("HH:mm")
                        : ""
                    }
                    onChange={(e) => {
                      const selectedTime = e?.target?.value;
                      if (editData.ToPublishDate && selectedTime) {
                        const formattedDateTime = `${
                          editData.ToPublishDate.split("T")[0]
                        }T${selectedTime}`;
                        setEditData({
                          ...editData,
                          ProductExpiringTime: formattedDateTime,
                        });
                      }
                      setEditErrorMessage({
                        ...editErrorMessage,
                        ProductExpiringTime: "",
                      });
                    }}
                  />
                  {editErrorMessage?.ProductExpiringTime ? (
                    <div className="validation-message">
                      {editErrorMessage?.ProductExpiringTime}
                    </div>
                  ) : null}
                </div>
              </div>
              <div className="col-lg-12">
                <div className="form-group">
                  <label for="combinedDateTime">Product Expire At</label>
                  <input
                    id="combinedDateTime"
                    type="datetime-local"
                    className="form-control"
                    readonly
                    disabled
                    value={
                      editData.ToPublishDate && editData.ProductExpiringTime
                        ? moment(
                            editData.ProductExpiringTime.split("T")[0] +
                              "T" +
                              editData.ProductExpiringTime.split("T")[1].slice(
                                0,
                                5
                              )
                          ).format("YYYY-MM-DDTHH:mm")
                        : ""
                    }
                  />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="form-group">
                  <label className="required-label">
                    Product Publish?
                    <span className="required">*</span>
                  </label>
                  <div className="product-publish-div">
                    <div>
                      <input
                        type="radio"
                        id="publishYes"
                        name="isPublish"
                        checked={editData?.IsPublish === true}
                        onChange={() => {
                          setEditData({ ...editData, IsPublish: true });
                          setEditErrorMessage({
                            ...editErrorMessage,
                            IsPublish: "",
                          });
                        }}
                      />
                      <label for="publishYes">Yes</label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        id="publishNo"
                        name="isPublish"
                        checked={editData?.IsPublish === false}
                        onChange={() => {
                          setEditData({ ...editData, IsPublish: false });
                          setEditErrorMessage({
                            ...editErrorMessage,
                            IsPublish: "",
                          });
                        }}
                      />
                      <label for="publishNo">No</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="form-group">
                  <label>
                    Upload Image{" "}
                    <span>
                      (700 * 400)
                      <span>*</span>
                    </span>
                  </label>

                  <form id="imageForm">
                    <input
                      className="form-control custom-file-input"
                      accept="image/png, image/jpeg, image/gif"
                      id="inputFile1"
                      type="file"
                      multiple
                      onChange={handleEditImageUpload}
                    />
                  </form>
                </div>
                {/* <span className="required">
                  Note: Your old images will be removed. Please upload new
                  images.
                </span> */}
                {editErrorMessage?.Images ? (
                  <div className="validation-message">
                    {editErrorMessage?.Images}
                  </div>
                ) : null}
              </div>
              {/* {!editData?.length ?

                                <img src={editData?.Images} className="popup_pro_img" alt="Product Image" id="proImg"></img>
                                : null} */}

              <div className="Uploaded-Image">
                {oldImages
                  ?.filter((item) => !item.IsDelete)
                  .map((item, index) => {
                    return (
                      <div
                        className="d-flex flex-column upload-div-image"
                        key={index}
                      >
                        <img src={`${Apiurl()}/${item.Images}`} alt="" />
                        <input
                          type="radio"
                          id={`old-image-${index}`}
                          name="selectedImage"
                          value={index}
                          checked={item?.Default}
                          onChange={() => handleRadioChange(item?.Id)}
                        />
                        <IoMdClose
                          className="close_icon_image"
                          onClick={() => handleDelete(item?.Id)}
                        />
                      </div>
                    );
                  })}
              </div>
              <div
                className="cropper-container"
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: "15px",
                  paddingTop: "10px",
                }}
              >
                {editImages?.map((image, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      width: "200px",
                    }}
                  >
                    {/* Cropper */}
                    <Cropper
                      src={image}
                      className="cropper_value"
                      style={{
                        height: "100px",
                        width: "200px",
                        border: "1px solid #ccc",
                        marginBottom: "10px",
                      }}
                      initialAspectRatio={700 / 400}
                      aspectRatio={700 / 400}
                      viewMode={1}
                      guides={true}
                      minCropBoxWidth={700}
                      minCropBoxHeight={400}
                      responsive={true}
                      autoCropArea={1}
                      onInitialized={
                        (instance) => (cropperRefs.current[index] = instance) // Save cropper instance
                      }
                    />

                    {/* <input
                      type="radio"
                      id={`image-${index}`}
                      name="selectedImage"
                      value={index}
                      checked={selectedEditImageIndex === index}
                      onChange={() => setSelectedEditImageIndex(index)}
                    /> */}
                    <input
                      type="radio"
                      id={`edit-image-${index}`}
                      name="selectedImage"
                      value={index}
                      checked={selectedEditImageIndex === index}
                      onChange={() => handleEditImageChange(index)}
                    />
                    <label htmlFor={`image-${index}`}>
                      Select Image {index + 1}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </form>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="common_btn btn-secondary"
          data-bs-dismiss="modal"
          onClick={() => {
            setEditData({
              ...editData,
              BannerIds: "",
              ProductName: "",
              Mrp: "",
              DealPrice: "",
              BrandName: "",
              EntryDate: "",
              FromPublishDate: "",
              ToPublishDate: "",
              ProductExpiringTime: "",
              Quantity: "",
              IsProductInOffer: "",
              ProductDescription: "",
              RecommendedBid: "",
              IsPublish: "",
              Images: "",
            });
            setEditModal(false);
          }}
        >
          Cancel
        </button>
        {loading == "update" ? (
          <button type="button" className="common_btn view-data-btn">
            <ClipLoader className="main_loader_home" loading size={15} />
          </button>
        ) : (
          <button
            type="button"
            className="common_btn view-data-btn"
            onClick={handleUpdateProduct}
          >
            Update
          </button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default UploadandListingEditProductModal;
